import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function LocationIcon(props: IIcon) {
    const newViewProps = '0 0 14 20' ?? props.viewBox;
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={newViewProps}
            style={props.style}
            className={props.className}
        >
            <g>
                <path d="M7.2,0.2c-0.067,-0.002 -0.133,-0.003 -0.2,-0.003c-3.84,0 -7,3.16 -7,7c0,0.001 0,0.002 0,0.003c0,4.5 4.3,7.7 6.7,12.4c0.1,0.2 0.5,0.2 0.6,0c2.2,-4.2 5.9,-7 6.6,-11c0.108,-0.493 0.163,-0.996 0.163,-1.501c0,-3.789 -3.075,-6.925 -6.863,-6.999l0,0.1Zm-0.2,10.8c-2.03,0 -3.7,-1.67 -3.7,-3.7c0,-2.03 1.67,-3.7 3.7,-3.7c2.03,0 3.7,1.67 3.7,3.7c0,2.03 -1.67,3.7 -3.7,3.7Z" />
            </g>
        </Icon>
    );
}
